export default class AbstractPageBaseController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.rootScope = this.injector.get('$rootScope');
        this.stateParams = this.injector.get('$stateParams');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.translate = this.injector.get('$translate');
    }
}

AbstractPageBaseController.$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/core/abstracts/controllers/page-controller.js